import { render, staticRenderFns } from "./InsertionOrderDocument.vue?vue&type=template&id=f70bdd8c&scoped=true&"
import script from "./InsertionOrderDocument.vue?vue&type=script&lang=js&"
export * from "./InsertionOrderDocument.vue?vue&type=script&lang=js&"
import style0 from "./InsertionOrderDocument.vue?vue&type=style&index=0&id=f70bdd8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70bdd8c",
  null
  
)

export default component.exports